import isNumber from "lodash/isNumber";

import {IntervalFrequency, MonitoringServiceType, MSPInterval} from "@/lib/types/checks.ts";
import {CheckFrequency} from "@/lib/types/devices.ts";
import {IntervalInputGroupField} from "@/pages/checks/components/form/fields/interval/IntervalInputGroupField.tsx";
import {IntervalReadOnlyField} from "@/pages/checks/components/form/fields/interval/IntervalReadOnlyField.tsx";
import {
  getCheckMaxInterval,
  getCheckMinInterval,
  IntervalFieldType,
} from "@/pages/checks/components/form/fields/interval/utils.ts";

interface IntervalFieldProps {
  className?: string;
  intervalLabel?: string;
  name: string;
  svcType: MonitoringServiceType;
  limit_check_frequency: CheckFrequency;
  mspInterval: MSPInterval;
  intervalFrequency?: number | IntervalFrequency;
  forceInterval?: number;
  fieldType: IntervalFieldType;
  forceMaxInterval?: number;
  lockedTooltip?: string;
}

export const IntervalField = ({
  name,
  svcType,
  className,
  intervalFrequency,
  limit_check_frequency,
  mspInterval,
  intervalLabel,
  forceInterval,
  fieldType,
  forceMaxInterval,
  lockedTooltip,
}: IntervalFieldProps) => {
  if (fieldType === IntervalFieldType.NONE) {
    return null;
  }

  const min = getCheckMinInterval(intervalFrequency, limit_check_frequency, mspInterval.min);

  const max = forceMaxInterval ?? getCheckMaxInterval(svcType);
  if (isNumber(forceInterval) || min === max) {
    fieldType = IntervalFieldType.FIXED;
  }

  return (
    <>
      {fieldType === IntervalFieldType.FIXED && (
        <IntervalReadOnlyField
          className={className}
          name={name}
          value={isNumber(forceInterval) ? forceInterval : min}
          lockedTooltip={lockedTooltip}
        />
      )}
      {fieldType === IntervalFieldType.INPUT_GROUP && (
        <IntervalInputGroupField
          className={className}
          name={name}
          intervalLabel={intervalLabel}
          max={max}
          min={min}
          lockedTooltip={lockedTooltip}
        />
      )}
    </>
  );
};
